import { doc, setDoc, deleteDoc, serverTimestamp, collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";

/**
 * FCM 토큰 저장
 * 문서 ID = {uid}_{platform} (중복 방지)
 */
export async function saveFcmToken(uid, token, platform = "web") {
  if (!uid || !token) return;
  const docId = `${uid}_${platform}`;
  const ref = doc(db, "fcmTokens", docId);
  await setDoc(ref, {
    uid,
    token,
    platform,
    updatedAt: serverTimestamp(),
  }, { merge: true });
}

/**
 * FCM 토큰 삭제 (로그아웃 시)
 * 해당 uid의 모든 토큰 삭제
 */
export async function removeFcmToken(uid) {
  if (!uid) return;
  try {
    const q = query(collection(db, "fcmTokens"), where("uid", "==", uid));
    const snap = await getDocs(q);
    const deletes = snap.docs.map((d) => deleteDoc(d.ref));
    await Promise.all(deletes);
  } catch (e) {
    console.warn("FCM 토큰 삭제 실패 (무시):", e.message);
  }
}
